import { InputHTMLAttributes, Ref, forwardRef } from 'react';

import Input from './Input';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  styleWidthSize?: string;
  leftIcon?: React.ReactNode;
  rightAction?: React.ReactNode;
  hasError?: boolean;
  label?: React.ReactElement | string;
}

/** 상태별 스타일은 globals.css 의 .input-line* 클래스에 있다 */
const InputLine = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = 'text',
      styleWidthSize = 'auto',
      label,
      leftIcon,
      rightAction,
      disabled,
      readOnly,
      hasError,
      className,
      ...props
    },
    ref: Ref<HTMLInputElement>,
  ) => {
    const hasLabel = Boolean(label);

    return (
      <label
        className={[
          'input-line',
          hasLabel && 'input-line--has-label',
          hasError && 'input-line--error',
          readOnly && 'input-line--readonly',
          disabled && 'input-line--disabled',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        style={{ width: styleWidthSize }}
      >
        {leftIcon && <div className="flex-[1_0_0]">{leftIcon}</div>}
        <div
          className={`input-line__field ${hasLabel ? 'input-line__field--has-label' : ''}`}
        >
          <Input
            type={type}
            ref={ref}
            hasError={hasError}
            disabled={disabled}
            readOnly={readOnly}
            className={[
              'input-line__input',
              hasLabel && 'input-line__input--has-label',
              (hasError || readOnly) && 'input-line__input--muted-label',
            ]
              .filter(Boolean)
              .join(' ')}
            {...props}
          />
          {label && <div className="input-line__label">{label}</div>}
        </div>
        {rightAction && <div className="flex-[1_0_0]">{rightAction}</div>}
      </label>
    );
  },
);

InputLine.displayName = 'InputLine';

export default InputLine;
